import { Notyf }            from    'notyf';
// import FormResources        from './form_resources';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const Methods = {
    methods: {

        async form_submit(flag)
        {
            let assignments_selected = this.$refs.advanced_search.returnedAsssignmentsToParent()

            if(!assignments_selected.checked_items.length)
            {
                notyf.error('No assignments selected')
                return false
            }

            if(!flag)
            {
                window.$('#confirmation-fields-modal').modal('show')
                return false
            }
            else if(flag)
            {
                window.$('#confirmation-fields-modal').modal('hide')
            }

            assignments_selected.checked_items = assignments_selected.checked_items.map(item => item.id)
            assignments_selected.unchecked_items = assignments_selected.unchecked_items.map(item => item.id)

            this.loader(true)


            const response = await this.post(`${this.rest_api}_mass_edit`, {...this.form_data, ...assignments_selected})

            if(response.status)
            {
                notyf.success('Success')
                this.form_data = {...this.form_backup}
                this.$refs.advanced_search.resetList()

            }
            else
            {
                notyf.error('Error')
                this.error_handling(response)
            }

            this.loader()
        },

        getInitialData(data)
        {
            this.array_options = {
                supervisor_associate_id: data.supervisors,
                shift_id: data.shifts,
                group_id: data.groups,
                cost_center_department_id: data.cost_center_departments,
                day_id: data.days
            }
        }
    }
}

export default Methods